import { BACKBONE } from 'constants/store.constants';

const selectBackboneSlice = (state) => state[BACKBONE];
export const selectBackboneData = (state) => selectBackboneSlice(state).backboneData;
export const selectBackboneNames = (state) => selectBackboneData(state).backbones;
export const selectMHCAlleles = (state) => selectBackboneSlice(state).mhcAlleles;
